import { JobPipelineService } from '../../services/job-pipeline-service';
import Global from '../../store/global-selectors';
import { genericErrorHandlingForScanToPrint } from '../../store/scan-to-print/s2p-purchase-and-print.actions';
import { advanceQueue, resetScanToPrintMode } from '../../store/scan-to-print/scan-to-print.actions';

// Steps
import GetFulfillments from './steps/get-fulfillments';
import PrintScanToPrintLabel from './steps/print-scan-to-print-label';

export const REPRINT_LABEL_IN_SCAN_TO_PRINT = 'REPRINT_LABEL_IN_SCAN_TO_PRINT';

const pipeline = [GetFulfillments, PrintScanToPrintLabel];

JobPipelineService.registerPipeline(REPRINT_LABEL_IN_SCAN_TO_PRINT, {
  pipeline,
  initialData: {},
  onExit: (jobId, state) => {
    const jobData = Global.selectJobPipelineJobDataByJobId(state, { jobId });
    const { errors } = jobData;
    if (errors) {
      return genericErrorHandlingForScanToPrint(errors);
    }

    const queue = Global.selectScanToPrintQueue(state);
    if (queue?.isActive) {
      // Don't reset when queue is active - let the epic handle advancement
      return advanceQueue();
    }

    return resetScanToPrintMode();
  },
});
